// Do not modify this file; it is generated as part of publish.
// The checked in version is a placeholder only and will not be updated.
import { setVersion } from '@uifabric/set-version';
setVersion('office-ui-fabric-react', '7.139.2');
//# sourceMappingURL=version.js.map